import { Component, Inject, OnInit, ViewChild , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_545';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Indique el valor de los ingresos recibidos ', listHelp: ['479'] },
  { text: "2", active: false, completed: false, tooltip: 'Indique el valor total de rebajas, descuentos y devoluciones sobre esos ingresos ', listHelp: ['531'] },


];
@Component({
  selector: 'app-renta-no-laboral-comerciante-modal',
  templateUrl: './renta-no-laboral-comerciante-modal.component.html',
  styleUrls: ['./renta-no-laboral-comerciante-modal.component.css'],
})
export class RentaNoLaboralComercianteModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  showSave:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<RentaNoLaboralComercianteModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateShowSave();
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_479 == undefined)this.model.doc.cuerpo.cs_id_479="0"; 
    if(this.model.doc.cuerpo.cs_id_531 == undefined)this.model.doc.cuerpo.cs_id_531="0";
  }

  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
   
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
  
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
  
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    //Si no ha respondido en go15CasaNacional no puede saltar preguntas
    if( (indexS>=5 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_793==undefined || this.model.doc.cuerpo.cs_id_793=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en go15CasaNacional debe saltar preguntas del indexStepper
    else if( (indexS==5 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_793=="0")) ){
      habilitado = false;
    }
    //Si no ha respondido en go16CasaAFC no puede saltar preguntas
    if( (indexS>=8 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_761==undefined || this.model.doc.cuerpo.cs_id_761=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en go16CasaAFC debe saltar preguntas del indexStepper
    else if( (indexS==8 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_761=="0")) ){
      habilitado = false;
    }

    //Si no ha respondido en go17RentaAnterior no puede saltar preguntas
    if( (indexS>=10 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_757==undefined || this.model.doc.cuerpo.cs_id_757=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en go17RentaAnterior debe saltar preguntas del indexStepper
    else if( (indexS==10 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_757=="0")) ){
      habilitado = false;
    }
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
   
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 479:
        this.OperacionCs479();
        break;
    
      case 531:
        this.OperacionCs531();
        break;
        
             
   }
   if(soloEstaCasilla)return;

   
   let resultado = "0";
  }

OperacionCs479() {
	let cas479 = this.model.doc.cuerpo.cs_id_479
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas479,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los ingresos no pueden ser cero");
      return
   }                    
 }
 //rebajas 
OperacionCs531() {
	//no tiene validaciones
}
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ 
      this.showSave=true 
    };
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-comerciante-modal/renta-no-laboral-comerciante-modal.component.ts